const data = {
    backgroundColor: "#1e222d",
    foregroundColor: "#5d7d93",
}


export default data;